module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/heading-plan-9da0a7c4bfe0472a2ad6de15bf44d4ad.svg";